import React from "react";
import ConnectionStatusBadge from "./ConnectionStatusBadge";
import "../../../components/ui-components/DataTable.css";

const ValidationHistory = ({ history }) => {
  if (!history || history.length === 0) {
    return (
      <div className="text-sm text-text-2 text-center py-6">No validation history yet.</div>
    );
  }

  return (
    <table className="data-table w-full text-sm">
      <thead>
        <tr>
          <th className="py-2 px-3 font-medium">Timestamp</th>
          <th className="py-2 px-3 font-medium">Result</th>
          <th className="py-2 px-3 font-medium">Details</th>
        </tr>
      </thead>
      <tbody>
        {history.map((entry, i) => (
          <tr key={i}>
            <td className="py-2.5 px-3 text-text-2">
              {new Date(entry.timestamp).toLocaleString()}
            </td>
            <td className="py-2.5 px-3">
              <ConnectionStatusBadge status={entry.result} />
            </td>
            <td className="py-2.5 px-3 text-text-2">{entry.details}</td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

export default ValidationHistory;
